// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.area-custo[data-v-597a107b] {\n  width: 212px;\n}\n.valor[data-v-597a107b] {\n  font-weight: 600;\n  font-size: 24px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
